(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "vue"], factory);
	else if(typeof exports === 'object')
		exports["saas-billing"] = factory(require("lodash"), require("vue"));
	else
		root["saas-billing"] = factory(root["lodash"], root["vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_24__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(22)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(18),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(16),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(17),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(15),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		invoices: {
			type: Array,
			required: true
		}
	}
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stripe_StripeUpgrade_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stripe_StripeUpgrade_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stripe_StripeUpgrade_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		routes: {
			type: Object,
			default: {
				form_post_update: ''
			}
		},
		stripeForm: {
			type: Object,
			required: true
		},
		paymentInfo: {
			type: Object,
			default: function _default() {
				return {
					card_brand: '',
					card_last_four: '',
					billing_address: '',
					billing_city: '',
					billing_state: '',
					billing_zip: '',
					billing_country: ''
				};
			}
		}
	},

	computed: {
		hasPaymentInfo: function hasPaymentInfo() {
			return this.paymentInfo.card_brand;
		},
		billingAddress: function billingAddress() {
			var address = '';

			address += this.paymentInfo.billing_address ? this.paymentInfo.billing_address + ', ' : '';
			address += this.paymentInfo.billing_city ? this.paymentInfo.billing_city + ', ' : '';
			address += this.paymentInfo.billing_state ? this.paymentInfo.billing_state + ', ' : '';
			address += this.paymentInfo.billing_zip ? this.paymentInfo.billing_zip + ', ' : '';
			address += this.paymentInfo.billing_country ? this.paymentInfo.billing_country + ', ' : '';
			address = address.replace(/\, $/, '');

			return address;
		}
	},

	components: {
		'stripe-upgrade': __WEBPACK_IMPORTED_MODULE_0__stripe_StripeUpgrade_vue___default.a
	}
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stripe_StripeUpgrade_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stripe_StripeUpgrade_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stripe_StripeUpgrade_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		routes: {
			type: Object,
			default: {
				cancel_subscription: '',
				resume_subscription: '',
				change_plan: '',
				form_post_subscribe: ''
			}
		},
		stripeForm: {
			type: Object,
			required: true
		},
		plans: {
			type: Array,
			required: true
		},
		subscription: {
			type: Object,
			default: function _default() {
				return {
					stripe_plan: '',
					cancelled: false,
					on_grace_period: false,
					ends_at: null
				};
			}
		},
		coupon: {
			type: String,
			default: ''
		}
	},

	data: function data() {
		return {
			activePlan: null
		};
	},


	computed: {
		hasSubscription: function hasSubscription() {
			return !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(this.subscription);
		},
		hasActiveSubscription: function hasActiveSubscription() {
			return this.hasSubscription && !this.subscriptionIsExpired;
		},
		subscriptionIsExpired: function subscriptionIsExpired() {
			if (!this.hasSubscription) {
				return false;
			}

			return this.subscription.cancelled && !this.subscription.on_grace_period;
		},
		showResumeAlert: function showResumeAlert() {
			if (!this.hasSubscription) {
				return false;
			}

			return this.subscription.cancelled && this.subscription.on_grace_period;
		},
		showPricingTable: function showPricingTable() {
			if (!this.hasSubscription) {
				return true;
			}

			return !this.subscription.cancelled || this.subscriptionIsExpired;
		}
	},

	mounted: function mounted() {
		this.setActivePlan();
	},


	methods: {
		setActivePlan: function setActivePlan() {
			if (this.hasSubscription && this.plans.length) {
				this.activePlan = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.plans, { 'id': this.subscription.stripe_plan });
			}
		},
		isCurrentPlan: function isCurrentPlan(planId) {
			if (!this.hasSubscription && !planId) {
				// Free plan
				return true;
			}

			return this.hasSubscription && this.subscription.stripe_plan == planId;
		},
		showCancelButton: function showCancelButton() {
			if (!this.hasSubscription) {
				return false;
			}

			return !this.subscription.cancelled;
		},
		confirmCancel: function confirmCancel(e) {
			if (!confirm('Are you sure you want to cancel your subscription?')) {
				e.preventDefault();
			}
		},
		showChangeButton: function showChangeButton(planId) {
			return this.hasActiveSubscription && planId;
		},
		changeButtonText: function changeButtonText(planId) {
			if (this.isCurrentPlan(planId)) {
				return 'Current Plan';
			}

			return 'Change Plan';
		},
		confirmChange: function confirmChange(e) {
			if (e.target.getAttribute('disabled')) {
				e.preventDefault();
				return;
			}

			if (!confirm('Are you sure you want to change your subscription? You will be charged a prorated amount now, then the new rate going forward.')) {
				e.preventDefault();
			}
		},
		showUpgradeButton: function showUpgradeButton(planId) {
			return !this.hasActiveSubscription && planId;
		}
	},

	watch: {
		subscription: function subscription() {
			this.setActivePlan();
		}
	},

	components: {
		'stripe-upgrade': __WEBPACK_IMPORTED_MODULE_1__stripe_StripeUpgrade_vue___default.a
	}
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['formData', 'action', 'text', 'plan', 'coupon'],

	data: function data() {
		return {
			stripe: null,
			stripeToken: '',
			billing_name: '',
			billing_address_country: '',
			billing_address_zip: '',
			billing_address_state: '',
			billing_address_line1: '',
			billing_address_city: '',
			billing_address_country_code: ''
		};
	},
	created: function created() {
		var _this = this;

		this.stripe = StripeCheckout.configure({
			key: this.formData.stripe_key,
			name: this.formData.app_name,
			email: this.formData.user_email,
			locale: 'auto',
			zipCode: true,
			billingAddress: true,
			allowRememberMe: false,
			token: function token(_token, args) {
				_this.stripeToken = _token.id;
				_this.billing_name = args.billing_name;
				_this.billing_address_country = args.billing_address_country;
				_this.billing_address_zip = args.billing_address_zip;
				_this.billing_address_state = args.billing_address_state;
				_this.billing_address_line1 = args.billing_address_line1;
				_this.billing_address_city = args.billing_address_city;
				_this.billing_address_country_code = args.billing_address_country_code;

				__WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
					_this.$el.submit();
				});
			}
		});
	},


	methods: {
		open: function open() {
			if (this.plan) {
				this.stripe.open({
					description: this.plan.name + ' plan',
					amount: this.plan.price * 100,
					panelLabel: 'Pay {{amount}} ' + this.plan.interval
				});
			} else {
				this.stripe.open({
					panelLabel: 'Update Card Details'
				});
			}
		}
	}
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PlanAndPricing_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PlanAndPricing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PlanAndPricing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PaymentInfo_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PaymentInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PaymentInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PaymentHistory_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PaymentHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PaymentHistory_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PlanAndPricing", function() { return __WEBPACK_IMPORTED_MODULE_0__components_PlanAndPricing_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PaymentInfo", function() { return __WEBPACK_IMPORTED_MODULE_1__components_PaymentInfo_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PaymentHistory", function() { return __WEBPACK_IMPORTED_MODULE_2__components_PaymentHistory_vue___default.a; });




/* harmony default export */ __webpack_exports__["default"] = ({
	install: function install(Vue) {
		Vue.component('plan-and-pricing', __WEBPACK_IMPORTED_MODULE_0__components_PlanAndPricing_vue___default.a);
		Vue.component('payment-info', __WEBPACK_IMPORTED_MODULE_1__components_PaymentInfo_vue___default.a);
		Vue.component('payment-history', __WEBPACK_IMPORTED_MODULE_2__components_PaymentHistory_vue___default.a);
	}
});



/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".pricing-table{margin-bottom:0}.pricing-table tbody tr td{border:0}.pricing-table .features{list-style:none;margin:0;padding:0}.pricing-table .table-spacer{padding:7px 5px}.resume-alert{margin-bottom:0}.coupon-alert,.plan-and-pricing-panel .cancel-btn{margin-top:20px}.coupon-alert{margin-bottom:0}", ""]);

// exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".payment-history-table .table-spacer{padding:4px 5px}", ""]);

// exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".payment-info-spacer{padding:7px 5px}", ""]);

// exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default plan-and-pricing-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Plan and Pricing")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.showResumeAlert) ? _c('div', {
    staticClass: "alert alert-warning resume-alert"
  }, [_c('p', [_vm._v("You have cancelled your subscription to the\n\t\t\t\t"), (_vm.activePlan) ? _c('strong', [_vm._v(_vm._s(_vm.activePlan.name) + " ($" + _vm._s(_vm.activePlan.price) + " " + _vm._s(_vm.activePlan.interval) + ")")]) : _vm._e(), _vm._v(" plan.\n\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("The benefits of your subscription will continue until your current billing period ends on\n\t\t\t\t"), (_vm.hasSubscription) ? _c('strong', [_vm._v(_vm._s(_vm.subscription.ends_at))]) : _vm._e(), _vm._v(". You may resume your subscription at no\n\t\t\t\textra cost until the end of the billing period.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.routes.resume_subscription
    }
  }, [_vm._v("Resume Subscription")])])]) : _vm._e(), _vm._v(" "), (_vm.showPricingTable) ? _c('table', {
    staticClass: "table pricing-table"
  }, [_c('tbody', _vm._l((_vm.plans), function(plan) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "table-spacer"
    }, [_c('strong', [_vm._v(_vm._s(plan.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "table-spacer"
    }, [_c('ul', {
      staticClass: "features"
    }, _vm._l((plan.features), function(feature) {
      return _c('li', [_vm._v(_vm._s(feature))])
    }))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "table-spacer"
    }, [_vm._v("\n\t\t\t\t\t\t$" + _vm._s(plan.price) + " " + _vm._s(plan.interval) + "\n\t\t\t\t\t\t"), (_vm.coupon) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.showChangeButton(plan.id)) ? _c('a', {
      staticClass: "btn",
      class: [_vm.isCurrentPlan(plan.id) ? 'btn-default' : 'btn-primary'],
      attrs: {
        "href": _vm.routes.change_plan + '?plan_id=' + plan.id,
        "disabled": _vm.isCurrentPlan(plan.id)
      },
      on: {
        "click": _vm.confirmChange
      }
    }, [_vm._v(_vm._s(_vm.changeButtonText(plan.id)))]) : _vm._e(), _vm._v(" "), (_vm.showUpgradeButton(plan.id)) ? _c('div', [(_vm.isCurrentPlan(plan.id)) ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "disabled": ""
      }
    }, [_vm._v("Current Plan")]) : _c('stripe-upgrade', {
      attrs: {
        "form-data": _vm.stripeForm,
        "action": _vm.routes.form_post_subscribe,
        "text": "Upgrade",
        "plan": plan,
        "coupon": _vm.coupon
      }
    })], 1) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showCancelButton()) ? _c('a', {
    staticClass: "btn btn-danger cancel-btn",
    attrs: {
      "href": _vm.routes.cancel_subscription
    },
    on: {
      "click": _vm.confirmCancel
    }
  }, [_vm._v("Cancel Subscription")]) : _vm._e(), _vm._v(" "), (_vm.coupon) ? _c('div', {
    staticClass: "alert alert-info coupon-alert"
  }, [_vm._v("\n\t\t\t* price before coupon is applied\n\t\t")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default payment-history-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Payment History")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.invoices.length) ? _c('table', {
    staticClass: "table payment-history-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "table-spacer"
    }, [_vm._v(_vm._s(invoice.date))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "table-spacer"
    }, [_vm._v(_vm._s(invoice.total))])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(invoice.link) ? _c('a', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "href": invoice.link
      }
    }, [_vm._v("Download")]) : _vm._e()])])
  }))]) : _c('em', [_vm._v("No invoices yet")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default payment-info-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Payment Information")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.hasPaymentInfo) ? _c('div', [_c('div', {
    staticClass: "pull-right"
  }, [_c('stripe-upgrade', {
    attrs: {
      "form-data": _vm.stripeForm,
      "action": _vm.routes.form_post_update,
      "text": "Update Details"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "payment-info-spacer"
  }, [_c('p', [_c('strong', [_vm._v("Card:")]), _vm._v(" " + _vm._s(_vm.paymentInfo.card_brand) + " ending in "), _c('strong', [_vm._v(_vm._s(_vm.paymentInfo.card_last_four))])]), _vm._v(" "), (_vm.billingAddress) ? _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('strong', [_vm._v("Address:")]), _vm._v(" " + _vm._s(_vm.billingAddress))]) : _vm._e()])]) : _c('em', [_vm._v("No payment information added yet")])])])
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": _vm.action,
      "method": "post"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.csrf_token),
      expression: "formData.csrf_token"
    }],
    attrs: {
      "type": "hidden",
      "name": "_token"
    },
    domProps: {
      "value": (_vm.formData.csrf_token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.csrf_token = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.plan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan.id),
      expression: "plan.id"
    }],
    attrs: {
      "type": "hidden",
      "name": "plan_id"
    },
    domProps: {
      "value": (_vm.plan.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plan.id = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stripeToken),
      expression: "stripeToken"
    }],
    attrs: {
      "type": "hidden",
      "name": "stripeToken"
    },
    domProps: {
      "value": (_vm.stripeToken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stripeToken = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing_name),
      expression: "billing_name"
    }],
    attrs: {
      "type": "hidden",
      "name": "billing_name"
    },
    domProps: {
      "value": (_vm.billing_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing_address_country),
      expression: "billing_address_country"
    }],
    attrs: {
      "type": "hidden",
      "name": "billing_address_country"
    },
    domProps: {
      "value": (_vm.billing_address_country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing_address_country = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing_address_zip),
      expression: "billing_address_zip"
    }],
    attrs: {
      "type": "hidden",
      "name": "billing_address_zip"
    },
    domProps: {
      "value": (_vm.billing_address_zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing_address_zip = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing_address_state),
      expression: "billing_address_state"
    }],
    attrs: {
      "type": "hidden",
      "name": "billing_address_state"
    },
    domProps: {
      "value": (_vm.billing_address_state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing_address_state = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing_address_line1),
      expression: "billing_address_line1"
    }],
    attrs: {
      "type": "hidden",
      "name": "billing_address_line1"
    },
    domProps: {
      "value": (_vm.billing_address_line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing_address_line1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing_address_city),
      expression: "billing_address_city"
    }],
    attrs: {
      "type": "hidden",
      "name": "billing_address_city"
    },
    domProps: {
      "value": (_vm.billing_address_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing_address_city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing_address_country_code),
      expression: "billing_address_country_code"
    }],
    attrs: {
      "type": "hidden",
      "name": "billing_address_country_code"
    },
    domProps: {
      "value": (_vm.billing_address_country_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billing_address_country_code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.coupon) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coupon),
      expression: "coupon"
    }],
    attrs: {
      "type": "hidden",
      "name": "coupon"
    },
    domProps: {
      "value": (_vm.coupon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coupon = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(12);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("607a4130", content, true);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(13);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3513cb00", content, true);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(14);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("37d1f900", content, true);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_23__;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// saas-billing.js